/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useRef } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _, { sortBy } from 'lodash';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { DisputeCodesSelected, ManufactureTableHead } from './TableHead';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import {
  handleScrollToEvent,
  lowerCaseAllWordsExceptFirstLetters,
  redirectURLLink,
  upperCaseFirstLetter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

import {
  dispatchErrorMsgDisputeActivity,
  dispatchPerformDisputeResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchErrorMsgNDCDetail,
  getSelectedCode,
  dispatchDisputeCode,
  getManufactureName,
  getManufactureID,
  getSelectedOption,
  dispatchDrugData,
  dispatchStatus,
  getManufacturerList,
  getMFGGrid,
  getNDCGrid,
  dispatchRebateProgramName,
  dispatchDisplayObjActivity,
  dispatchMfgSelected,
  mfgWithDataToDisplay,
  showNoDataMessage,
} from '../Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
  ERRORMESSAGE_SELECT_CODE_VALUE,
} from '../../../../SharedModules/Errors/constantMessageData';
import { navigateToRequest, viewClaimDetailButton } from './ConstantData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import { drugSeqNum } from '../../../Maintain/DrugFamily/DrugFamilyDetails/store/actions';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const DisputeActivity = (props) => {
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.DisputeActivityReducer?.performDisputeResolutionObj
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.DisputeActivityReducer?.planType
  );
  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.DisputeActivityReducer?.rebateProgram
  );
  const resultManufacturerGrid = useSelector(
    (state) => state?.sharedState?.DisputeActivityReducer?.manufacturerList
  );
  const resultSelectedCode = useSelector(
    (state) => state?.sharedState?.DisputeActivityReducer?.selectedCode
  );
  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.DisputeActivityReducer?.errorMsgDisputeAct
  );

  const errorMsgNdcDetails = useSelector(
    (state) => state?.sharedState?.DisputeActivityReducer?.errorMsgNdcDetails
  );

  const ndcGridList = useSelector(
    (state) => state?.sharedState?.DisputeActivityReducer?.gridNDC
  );
  const mfgGridList = useSelector(
    (state) => state?.sharedState?.DisputeActivityReducer?.gridMFG
  );
  const fetchDisputeCodeList = useSelector(
    (state) => state?.sharedState?.DisputeActivityReducer?.disputeCodeOption
  );
  const {
    open,
    closed,
    selectedPlanType,
    ndcLeftTableData: ndcLeftTableDataArr,
    labelerSelectedRow: labelerSelectedRowValue,
    selectedSearchType,
    selectedNDC,
    selectByValue,
    selectedDisputeValue,
    checkedValue,
    selectedRowIndexValue,
    manufactureWithIds: manuIDValue,
    mfgListSelected,
  } = useSelector((state) => state?.sharedState?.DisputeActivityReducer);
  // const selectDisputeCodeList=
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  // get error msg for NDC
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      let alreadyPresentErrors = getErrorMsg?.searchScreenErrors
        ? getErrorMsg?.searchScreenErrors
        : [];
      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      alreadyPresentErrors = alreadyPresentErrors.concat(errors);
      dispatch(
        dispatchErrorMsgNDCDetail({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
        })
      );
    }
  };
  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          Open: true,
          Closed: false,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );
  const searchCompObj = requestCurrentDisData?.state?.searchTypeState;
  const [labelerFullScreen, setLabelerFullScreen] = React.useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = React.useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = React.useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = React.useState(
    labelerSelectedRowValue
  );

  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = React.useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = React.useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = React.useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] =
    React.useState(ndcLeftTableDataArr);
  const [openModal, setOpenModal] = React.useState(false);
  const [tempData, setTempData] = React.useState();
  const [ndcRightTableData, setNdcRightTableData] = React.useState(selectedNDC);
  const [ndcSearchVal, setNdcSearchVal] = React.useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = React.useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );

  const errorMessagesOfSearchTypeComp =
    getErrorMsg?.searchScreenErrors?.length > 0
      ? _.filter(
          getErrorMsg?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = React.useState(
    errorMessagesOfSearchTypeComp
  );

  const [radioList, setRadioList] = React.useState([]);
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [selectedCode, setSelectedCode] = React.useState([]);
  const gridRef = useRef();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [rebateProgramList, setRebateProgramList] =
    React.useState(getRebateProgramList);
  const [searchType, setSearchType] = React.useState(selectedSearchType);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const dispatch = useDispatch();
  const [selectedValue, setselectedValue] = React.useState(selectByValue);
  const [checked, setChecked] = React.useState(checkedValue);
  const [selectedDisputeCodes, setselectedDisputeCodes] =
    React.useState(selectedDisputeValue);
  const [disputeCodeList, setDisputeCodeList] = React.useState([]);
  const [selectedCodeValue, setSelectedCodeValue] = React.useState([]);
  const [gridApi, setGridApi] = React.useState(null);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectedErrorRows, setSelectedErrorRows] = React.useState([]);
  const [checkboxValues, setCheckboxValues] = React.useState({
    open: open,
    closed: closed,
  });
  const [selectedRowIndex, setSelectedRowIndex] = React.useState(
    selectedRowIndexValue
  );
  const [scrollDownManufacturers, setScrollDownManufacturers] =
    React.useState(true);
  const [menuName, setMenuName] = React.useState([]);
  const [manufacturerWithId, setManufactureWithId] =
    React.useState(manuIDValue);
  // dispatch function
  const setPerformDisputeScrData = (value) =>
    dispatch(dispatchPerformDisputeResolutionObj(value));

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    if (name === 'selectBy' && value !== state.selectBy) {
      setState({
        ...state,
        [name]: value,
        searchTypeState: {
          valueSelectedRedux: 'NDC',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });
      setSearchType(
        userDefaults?.defNdcSelectModeCd
          ? userDefaults?.defNdcSelectModeCd === 'NDC'
            ? 'NDC'
            : upperCaseFirstLetter(
                lowerCaseAllWordsExceptFirstLetters(
                  userDefaults?.defNdcSelectModeCd
                )
              )
          : 'NDC'
      );
      setNdcLeftSelectedRows([]);
      setlabelerSelectedRow('');
      setNdcRightSelectedRows([]);
      setlabelerTableData([]);
      setNdcLeftTableData([]);
      setNdcRightTableData([]);
      setNdcSearchVal('');
      setNdcNameSearchVal('');
      setPerformDisputeScrData({
        fullScreenView: fullScreenView,
        state: {
          ...state,
          [name]: value,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        },
      });
      localErr = localErr.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      setErrorMsgFromSearchType([]);
    }
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformDisputeScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformDisputeScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDisputeActivity({ searchScreenErrors: unique }));
  };
  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
      }
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDisputeActivity({ searchScreenErrors: unique }));
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg?.searchScreenErrors?.length > 0) {
      tabHighLigther(navigateToRequest, true);
    } else {
      tabHighLigther(navigateToRequest, false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // Grid functionality for mfg

  const [numberOfSelectedRows, setNumberOfSelectedRows] = React.useState(0);
  const onSelectionChanged = (e, isAllChecked) => {
    e.api.clearFocusedCell(); 
    if (isAllChecked) {
      const temp = [];
      const selectedMenuName = [];
      for (let i = 0; i < manufacturerList?.length; i += 1) {
        selectedMenuName.push(manufacturerList[i].mfgName);
        temp.push({
          manufacturerID: manufacturerList[i].mfgId,
          manufacturerName: manufacturerList[i].mfgName,
        });
      }
      selectedMenuName.sort();
      setMenuName(selectedMenuName);
      setManufactureWithId(temp);
      dispatch(dispatchMfgSelected([]));
    } else {
      const selectedRows = e.api?.getSelectedRows();
      setNumberOfSelectedRows(e.api?.getSelectedRows()?.length);
      const temp = [];
      const selectedMenuName = [];
      const selectedMfgId = selectedRows?.map((item) => item.mfgId);
      const selectedIndexes = [];
      manufacturerList.forEach((item, index) => {
        if (selectedMfgId.indexOf(item.mfgId) != -1) {
          selectedIndexes.push(index);
        }
      });
      dispatch(dispatchMfgSelected(selectedRows));
      setSelectedRowIndex(selectedIndexes);
      for (let i = 0; i < selectedRows?.length; i += 1) {
        selectedMenuName.push(selectedRows[i].mfgName);
        temp.push({
          manufacturerID: selectedRows[i].mfgId,
          manufacturerName: selectedRows[i].mfgName,
        });
      }
      selectedMenuName.sort();
      setMenuName(selectedMenuName);
      setManufactureWithId(temp);
      setSelectedRows(selectedRows);
      let localErr = getErrorMsg?.searchScreenErrors || [];
      localErr = localErr.filter((item) => item.field != 'nomanufacture');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgDisputeActivity({ searchScreenErrors: unique }));
    }
  };

  const getSelectedRowData = () => {
    const selectedData = this?.gridApi.getSelectedRows();
    return selectedData;
  };
  // Grid functionality for selected code
  const [numberOfSelectedCodeRows, setNumberOfSelectedCodeRows] =
    React.useState(0);
  
  const onGridReady = (params) => {
    setGridApi(params?.api);
  };

   // Listen for the first render of data
const onFirstDataRendered = (params) => {
    if (mfgListSelected?.length > 0 && params) {
        params.forEachNode(
          (node) =>
            -1 !==
              mfgListSelected?.findIndex((x) => {
                return x?.mfgId == node.data?.mfgId;
              }) && node.setSelected(true)
        );
    }
  };

  const onSelectionCodeChanged = (e) => {
    e.api.clearFocusedCell();
    const selectedCodeRows = e.api?.getSelectedRows();
    setNumberOfSelectedCodeRows(e.api?.getSelectedRows()?.length);

    if (
      selectedCodeRows?.length === disputeCodeList?.length ||
      selectedCodeRows?.length === 0
    ) {
    } else {
      const temp1 = [];
      const selectedCodeMenuName = [];
      for (let i = 0; i < selectedCodeRows?.length; i += 1) {
        temp1.push({
          codeValue: selectedCodeRows[i].codeValuetemp,
        });
      }
      selectedCodeMenuName.sort();

      setSelectedCodeValue(temp1);
      setSelectedErrorRows(selectedCodeRows);
      let localErr = getErrorMsg?.searchScreenErrors || [];
      localErr = localErr.filter((item) => item.field != 'noCodeSelected');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgDisputeActivity({ searchScreenErrors: unique }));
    }
  };
  const getSelectedCodeRowData = () => {
    const selectedCodeData = gridApi?.getSelectedCodeRows();
    return selectedCodeData;
  };

  // Search button on click functionality
  const onClickOnSearch = async () => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id === state.rebateProgramCd
    );
    const values = selectedCodeValue.map((obj) => obj.codeValue);
    let localErr = getErrorMsg?.searchScreenErrors || [];
    let sRows = (checked ? manufacturerList : selectedRows) || [];

    if (sRows?.length == 0) {
      localErr.push({
        field: 'nomanufacture',
        errorType: 'manufactureRequired',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }
    const cRows =
      selectedDisputeCodes === 'ALL' ? selectedCode : selectedErrorRows || [];
    if (cRows.length === 0) {
      localErr.push({
        field: 'noCodeSelected',
        errorType: 'selectedCodeRequired',
        message: ERRORMESSAGE_SELECT_CODE_VALUE,
      });
    }
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDisputeActivity({ searchScreenErrors: unique }));
    const a = ['ALL'];

    if (
      state.rebateProgramCd === '-1' ||
      sRows.length === 0 ||
      cRows.length === 0
    ) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      return;
    }
    let list = [];
    if (checked) {
      list = await dispatch(
        mfgWithDataToDisplay({
          disputeCode: selectedDisputeCodes === 'ALL' ? a : values,
          mfgId: ['ALL'],
          planType: state.planTypeCd,
          rebateProgramCD: rebateProgramName?.rebateProgramCd,
        })
      );
      if (list.length) {
        sRows = manufacturerList.filter(
          (obj) => list.indexOf(obj.mfgId) !== -1
        );
      } else {
        dispatch(showNoDataMessage());
        return;
      }
    }
    if (sRows?.length == 1) {
      const data = await dispatch(
        getMFGGrid({
          rebateProgramCD: rebateProgramName?.rebateProgramCd,
          mfgId: [sRows?.[0]?.mfgId],
          disputeCode: selectedDisputeCodes === 'ALL' ? a : values,
          openStatus: checkboxValues.open ? 1 : 0,
          closeStatus: checkboxValues.closed ? 1 : 0,
        })
      );
      if (!data?.length) {
        dispatch(showNoDataMessage());
        return;
      }
    }
    if (
      state.rebateProgramCd !== '-1' &&
      sRows?.length > 0 &&
      cRows?.length > 0
    ) {
      // const id = manufacturerWithId?.sort((a, b) =>
      //   a.manufacturerID > b.manufacturerID ? 1 : -1
      // )[0]?.manufacturerID;
      setSearchClicked(true);
      // dispatch(
      //   getMFGGrid({
      //     rebateProgramCD: rebateProgramName?.rebateProgramCd,
      //     mfgId: [id],
      //     disputeCode: selectedDisputeCodes === 'ALL' ? a : values,
      //     openStatus: checkboxValues.open ? 1 : 0,
      //     closeStatus: checkboxValues.closed ? 1 : 0,
      //   })
      // );
      dispatch(dispatchRebateProgramName(rebateProgramName));
      if (selectedDisputeCodes === 'ALL') {
        dispatch(dispatchDisputeCode(a));
      } else {
        dispatch(dispatchDisputeCode(values));
      }

      dispatch(getManufactureName(menuName));

      dispatch(getManufactureID(manufacturerWithId));
      dispatch(
        getSelectedOption({
          selectedPlanType: state.planTypeCd,
          checkedValue: checked,
          selectByValue: selectedValue,
          selectedDisputeValue: selectedDisputeCodes,
        })
      );

      dispatch(
        dispatchStatus({
          open: checkboxValues.open,
          closed: checkboxValues.closed,
        })
      );
      dispatch(
        dispatchDisplayObjActivity({
          open: checkboxValues.open,
          closed: checkboxValues.closed,
          selectedPlanType: state.planTypeCd,
          checkedValue: checked,
          selectByValue: selectedValue,
          selectedDisputeValue: selectedDisputeCodes,
          selectedRowIndexValue: selectedRowIndex,
          rebateProgramName,
          allManufacturer: menuName,
          manufactureWithIds: checked
            ? manufacturerWithId.filter(
                (obj) => list.indexOf(obj.manufacturerID) !== -1
              )
            : manufacturerWithId,
          disputeCodeOption: selectedDisputeCodes === 'ALL' ? a : values,
        })
      );

      // if (sRows?.length > 0 && sRows?.length !== 1) {
      //   redirectURLLink(
      //     '/displayDisputeActivity',
      //     'Display Dispute Activity Summary Report',
      //     props.history
      //   );
      //   dispatch(clearReduxForFilterAndSort('/displayDisputeActivity'));
      // }
    }
    redirectURLLink(
      '/displayDisputeActivity',
      'Display Dispute Activity Summary Report',
      props.history
    );
    dispatch(clearReduxForFilterAndSort('/displayDisputeActivity'));
  };
  // if (isSearchClicked && mfgGridList?.rebateDisputeActivityGridNdcVO) {
  //   setSearchClicked(false);
  //   redirectURLLink(
  //     '/displayDisputeActivity',
  //     'Display Dispute Activity Summary Report',
  //     props.history
  //   );
  //   dispatch(clearReduxForFilterAndSort('/displayDisputeActivity'));
  // }
  // ndc search
  const onSearch = async (data, bypass = false) => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id === state.rebateProgramCd
    );
    const values = selectedCodeValue.map((obj) => obj.codeValue);
    let localErr = getErrorMsg?.searchScreenErrors || [];
    const cRows =
      selectedDisputeCodes === 'ALL' ? selectedCode : selectedErrorRows || [];
    if (cRows.length === 0) {
      localErr.push({
        field: 'noCodeSelected',
        errorType: 'selectedCodeRequired',
        message: ERRORMESSAGE_SELECT_CODE_VALUE,
      });
    }
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDisputeActivity({ searchScreenErrors: unique }));
    if (state.rebateProgramCd === '-1' || cRows?.length === 0) {
      // if (cRows?.length !== 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      // }
      return;
    }
    const a = ['ALL'];
    if (data?.length > 1000 && !bypass) {
      setOpenModal(true);
      setTempData(data);
      return;
    }
    // if (state.rebateProgramCd !== '-1' && data?.length === 1) {
    // const drugSeq = data[0]?.drugSeqNum;
    // setSearchClicked(true);
    let res = await dispatch(
      getNDCGrid({
        rebateProgramCD: rebateProgramName?.rebateProgramCd,
        drugSeqNum: data.map((o) => o.drugSeqNum), //[drugSeq],
        disputeCode: selectedDisputeCodes == 'ALL' ? a : values,
        openStatus: checkboxValues.open ? 1 : 0,
        closeStatus: checkboxValues.closed ? 1 : 0,
      })
    );
    if (res.length) {
      let druglist = res.map((o) => o.drugSeqNum);
      let filtered = data
        .filter((o) => druglist.indexOf(o.drugSeqNum) !== -1)
        .sort((o, i) => (o.ndc > i.ndc ? 1 : -1));
      dispatch(dispatchRebateProgramName(rebateProgramName));

      if (selectedDisputeCodes == 'ALL') {
        dispatch(dispatchDisputeCode(a));
      } else {
        dispatch(dispatchDisputeCode(values));
      }
      dispatch(getManufactureName(menuName));
      dispatch(getManufactureID(manufacturerWithId));

      dispatch(
        getSelectedOption({
          rebateProgramName,
          selectedPlanType: state.planTypeCd,
          checked,
          selectedSearchType: searchType,
          selectByValue: selectedValue,
          selectedDisputeValue: selectedDisputeCodes,
        })
      );

      // data.sort((a, b) => a.drugSeqNum - b.drugSeqNum);

      dispatch(
        dispatchDrugData({
          selectedNDC: tempData ? tempData : data,
          ndcLeftTableData,
          labelerSelectedRow,
        })
      );
      dispatch(
        dispatchStatus({
          open: checkboxValues.open,
          closed: checkboxValues.closed,
        })
      );

      dispatch(
        dispatchDisplayObjActivity({
          open: checkboxValues.open,
          closed: checkboxValues.closed,
          drugData: filtered,
          ndcLeftTableData,
          labelerSelectedRow,
          rebateProgramName,
          selectedPlanType: state.planTypeCd,
          checked,
          selectedSearchType: searchType,
          selectByValue: selectedValue,
          selectedDisputeValue: selectedDisputeCodes,
          rebateProgramName,
          allManufacturer: menuName,
          manufactureWithIds: manufacturerWithId,
          disputeCodeOption: selectedDisputeCodes == 'ALL' ? a : values,
        })
      );
      // } else if (state.rebateProgramCd !== '-1' && cRows?.length > 0) {
      //   dispatch(dispatchRebateProgramName(rebateProgramName));

      //   if (selectedDisputeCodes === 'ALL') {
      //     dispatch(dispatchDisputeCode(a));
      //   } else {
      //     dispatch(dispatchDisputeCode(values));
      //   }

      //   dispatch(getManufactureName(menuName));
      //   dispatch(getManufactureID(manufacturerWithId));

      //   dispatch(
      //     getSelectedOption({
      //       rebateProgramName,
      //       selectedPlanType: state.planTypeCd,
      //       checked,
      //       selectedSearchType: searchType,
      //       selectByValue: selectedValue,
      //       selectedDisputeValue: selectedDisputeCodes,
      //     })
      //   );
      //   data.sort((a, b) => a?.drugSeqNum - b?.drugSeqNum);
      //   dispatch(
      //     dispatchDrugData({
      //       selectedNDC: data,
      //       ndcLeftTableData,
      //       labelerSelectedRow,
      //     })
      //   );
      //   dispatch(
      //     dispatchStatus({
      //       open: checkboxValues.open,
      //       closed: checkboxValues.closed,
      //     })
      //   );

      //   dispatch(
      //     dispatchDisplayObjActivity({
      //       open: checkboxValues.open,
      //       closed: checkboxValues.closed,
      //       drugData: data,
      //       ndcLeftTableData,
      //       labelerSelectedRow,
      //       rebateProgramName,
      //       selectedPlanType: state.planTypeCd,
      //       checked,
      //       selectedSearchType: searchType,
      //       selectByValue: selectedValue,
      //       selectedDisputeValue: selectedDisputeCodes,
      //       rebateProgramName,
      //       allManufacturer: menuName,
      //       manufactureWithIds: manufacturerWithId,
      //       disputeCodeOption: selectedDisputeCodes == 'ALL' ? a : values,
      //     })
      //   );
      redirectURLLink(
        '/displayDisputeActivity',
        'Display Dispute Activity Summary Report',
        props.history
      );
    }
  };
  const handleYes = () => {
    onSearch(
      tempData?.filter((o, i) => i < 1000),
      true
    );
    setTempData();
  };

  // if (
  //   isSearchClicked &&
  //   ndcGridList?.rebateDisputeActivityGridNdcVO?.length > 0
  // ) {
  //   setSearchClicked(false);
  //   redirectURLLink(
  //     '/displayDisputeActivity',
  //     'Display Dispute Activity Summary Report',
  //     props.history
  //   );
  //   dispatch(clearReduxForFilterAndSort('/displayDisputeActivity'));
  // }
  React.useEffect(() => {
    setChecked(checkedValue);
  }, [checkedValue]);

  const checkManufacturer = async () => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    setChecked(!checked);
    setScrollDownManufacturers(!scrollDownManufacturers);
    if (!checked) onSelectionChanged({}, !checked);
    const elem = document.getElementById('abc11');
    if (elem && scrollDownManufacturers) {
      //setTimeout(() => {
        await Promise.resolve();
        elem.scrollIntoView();
      //}, 1000);
    }
    localErr = localErr.filter((item) => item.field !== 'nomanufacture');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDisputeActivity({ searchScreenErrors: unique }));
  };
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setPerformDisputeScrData({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };

  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultManufacturerGrid?.rebatePercentOfSpendMfgGridVO);
  }, [resultManufacturerGrid]);
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);

  // Selected Code from API

  React.useEffect(() => {
    let data = resultSelectedCode?.ADJUSTMENT_DISPUTE_CD?.map((item) => {
      return {
        ...item,
        codeValuetemp: item.codeValueID.codeValue,
      };
    });
    data = sortBy(data, 'codeValuetemp');
    setSelectedCode(data);
  }, [resultSelectedCode]);
  React.useEffect(() => {
    dispatch(
      getSelectedCode({
        codeDomainList: ['ADJUSTMENT_DISPUTE_CD'],
      })
    );
  }, []);
  // handing by default multiple row selection function
  const onGridReady1 = (params) => {
    if (fetchDisputeCodeList && fetchDisputeCodeList?.length > 0) {
      params.api.forEachNode((node) => {
        node.rowIndex ==
          fetchDisputeCodeList.findIndex((x) => {
            return x === node.data?.codeValuetemp;
          }) && node.setSelected(true);
      });
    }
  };
  // For No Data validation for auto Scroll
  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && getErrorMsg?.searchScreenErrors?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);

  React.useEffect(() => {
    if (selectedValue === 'NDC') {
      dispatch(dispatchErrorMsgDisputeActivity({}));
    }
  }, [selectedValue]);

  const errorMessages = [
    ...new Set(getErrorMsg?.searchScreenErrors?.map((obj) => obj.message)),
  ];

  const manufactureErrors =
    getErrorMsg?.searchScreenErrors?.filter(
      (x) => x.field === 'nomanufacture'
    ) || [];
  const showError = manufactureErrors.length > 0;
  // Collect relevant error messages related to 'nomanufacture'
  const relevantErrorMessages = _.map(
    manufactureErrors,
    (error) => error.message
  );
  const displayedErrorMessages = new Set();
  const uniqueErrorMessages = relevantErrorMessages
    .filter((msg) => {
      if (!displayedErrorMessages.has(msg)) {
        displayedErrorMessages.add(msg);
        return true;
      }
      return false;
    })
    .join(', ');
    
  //remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgDisputeActivity({ searchScreenErrors: [] }));
  }, [state.planTypeCd, fullScreenView, selectedValue, ndcRightFullScreen, ndcLeftFullScreen, searchType, menuName, selectedCode, checkboxValues.open, checkboxValues.closed, selectedDisputeCodes, state.rebateProgramCd, ]);

  return (
    <div className=" tabs-container" data-testid="dispute-activity">
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Summary Reports" parent2="Dispute Activity" />
      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      {!fullScreenView && (
        <>
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="radio-button-for-rcdd"
                id="radio-button-for-rcdd_id"
                labelName="Plan Type"
                required
                optionList={radioList || []}
                defaultValue={state && state.planTypeCd}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'planTypeCd');
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>

            <div className="col-4 frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Select one Option <span className="mandatory"> *</span>{' '}
                </legend>
                <div className="form-wrapper p-2">
                  <div className="mui-custom-form with-select field-xl no-lbl" />
                </div>
                <div className="sub-radio no-margin">
                  <FormControl>
                    <RadioGroup
                      row
                      name="Select one Option"
                      required
                      value={selectedValue}
                    >
                      <FormControlLabel
                        style={{ marginRight: '10px' }}
                        value="NDC"
                        control={<Radio />}
                        label="NDC"
                        data-testid="disputeActivity-NDC"
                        onChange={(e) => setselectedValue(e.target.value)}
                      />
                      <FormControlLabel
                        style={{ marginRight: '10px' }}
                        value="Manufacturer"
                        control={<Radio />}
                        label="Manufacturer"
                        data-testid="disputeActivity-Manufacturer"
                        onChange={(e) => setselectedValue(e.target.value)}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </fieldset>
            </div>
            {selectedValue == 'Manufacturer' && (
              <div className="col-4" style={{ marginTop: '50px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked
                      color="primary"
                      name="allManufacturers"
                      onChange={checkManufacturer}
                      checked={checked}
                      value={menuName}
                    />
                  }
                  label="All Manufacturers"
                  className={showError ? 'all_mfg_err' : ''}
                />
                {showError && (
                  <div
                    className="alert alert-danger custom-alert text-left"
                    role="alert"
                  >
                    {uniqueErrorMessages}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Status</legend>
                <div className="form-wrapper p-2">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <RadioGroup row name="report-quarter" required>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValues.open}
                            color="primary"
                            name="open"
                            onChange={(e) => {
                              let value = {
                                ...checkboxValues,
                                open: !checkboxValues.open,
                              };
                              if (checkboxValues.open && !checkboxValues.closed)
                                value.closed = !checkboxValues.closed;
                              setCheckboxValues(value);
                            }}
                          />
                        }
                        label="Open"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValues.closed}
                            color="primary"
                            name="closed"
                            onChange={(e) => {
                              let value = {
                                ...checkboxValues,
                                closed: !checkboxValues.closed,
                              };
                              if (!checkboxValues.open && checkboxValues.closed)
                                value.open = !checkboxValues.open;
                              setCheckboxValues(value);
                            }}
                          />
                        }
                        label="Closed"
                      />
                    </RadioGroup>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-md-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Select Dispute Codes <span className="mandatory"> *</span>{' '}
                </legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <FormControl>
                        <RadioGroup
                          row
                          name="Selected Dispute Codes"
                          required
                          value={selectedDisputeCodes}
                        >
                          <FormControlLabel
                            style={{ marginRight: '90px' }}
                            value="ALL"
                            control={<Radio />}
                            label="All"
                            data-testid="disputeActivity-all"
                            onChange={(e) =>
                              setselectedDisputeCodes(e.target.value)
                            }
                          />
                          <FormControlLabel
                            value="Selected"
                            control={<Radio />}
                            label="Selected"
                            data-testid="disputeActivity-selected"
                            onChange={(e) =>
                              setselectedDisputeCodes(e.target.value)
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4 frr-two-col-radio ">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Rebate Program <span className="mandatory"> *</span>{' '}
                </legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      name="rebateProgram"
                      id="rebate_program"
                      label="Rebate Program"
                      data-testid="disputeActivity-rebateprg"
                      fullWidth
                      select
                      required
                      inputProps={{ maxLength: 11, id: 'rebate_program' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      helperText={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                      error={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      onChange={(e) =>
                        handleOnChangeEvent(e?.target?.value, 'rebateProgramCd')
                      }
                      value={
                        state && state.rebateProgramCd
                          ? state.rebateProgramCd
                          : ''
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {rebateProgramList?.length > 0
                        ? rebateProgramList.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </>
      )}
      <div className="row">
        {selectedValue == 'NDC' && (
          <div className="col-sm-12">
            <SearchTypeComponent
              id="claimAuditSelect"
              data-testid="NDC_Grid"
              viewDetailButtonName={viewClaimDetailButton}
              searchType={searchType}
              setSearchType={setSearchType}
              getErrorsFromSearchTypeComponent={
                getErrorsFromSearchTypeComponent
              }
              errorMsgFromSearchType={errorMsgFromSearchType}
              setLabelerFullScreen={setLabelerFullScreen}
              labelerFullScreen={labelerFullScreen}
              setNdcLeftFullScreen={setNdcLeftFullScreen}
              ndcLeftFullScreen={ndcLeftFullScreen}
              setNdcRightFullScreen={setNdcRightFullScreen}
              ndcRightFullScreen={ndcRightFullScreen}
              handleViewDetailFunction={onSearch}
              setlabelerSelectedRow={setlabelerSelectedRow}
              labelerSelectedRow={labelerSelectedRow}
              setNdcLeftSelectedRows={setNdcLeftSelectedRows}
              ndcLeftSelectedRows={ndcLeftSelectedRows}
              setNdcRightSelectedRows={setNdcRightSelectedRows}
              ndcRightSelectedRows={ndcRightSelectedRows}
              setlabelerTableData={setlabelerTableData}
              labelerTableData={labelerTableData}
              setNdcLeftTableData={setNdcLeftTableData}
              ndcLeftTableData={ndcLeftTableData}
              setNdcRightTableData={setNdcRightTableData}
              ndcRightTableData={ndcRightTableData}
              setNdcSearchVal={setNdcSearchVal}
              ndcSearchVal={ndcSearchVal}
              setNdcNameSearchVal={setNdcNameSearchVal}
              ndcNameSearchVal={ndcNameSearchVal}
              iconName="search"
            />
          </div>
        )}

        <div className="col-12 btn-wrapper mb-2">
          <div className="float-right mt-2 hide-on-print">
            {selectedValue == 'Manufacturer' && (
              <Button
                className="btn btn-success btn-search"
                data-testid="view_detail_ia"
                type="button"
                onClick={onClickOnSearch}
              >
                {' '}
                <SVGComponent iconName="Icon-search" /> {'  '} Search
              </Button>
            )}
          </div>
        </div>

        {selectedValue == 'Manufacturer' && !checked && (
          <div className="unallocated" style={{ width: '100vw' }} id="abc11">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              getSelectedRowData={getSelectedRowData}
              selectRowIndex={selectedRowIndexValue}
              ref={gridRef}
              gridCall={onGridReady}
              gridDataRendered={onFirstDataRendered}
              data-testid="onEditingStopped"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              columnDefs={ManufactureTableHead}
              rowData={manufacturerList || []}
              rowSelection="multiple"
              rowMultiSelectWithClick
              singleClickEdit
              exportFile
              animateRows
              sideBar={false}
              fileName="Manufacturer Grid"
              suppressRowClickSelection
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              hideColumnsInPdf
              onCellFocused={onCellFocused}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 30) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        )}

        {selectedDisputeCodes == 'Selected' && (
          <div className="unallocated" style={{ width: '100vw' }}>
            <TableGrid
              onSelectionChanged={onSelectionCodeChanged}
              getSelectedRowData={getSelectedCodeRowData}
              ref={gridRef}
              gridCall={onGridReady1}
              data-testid="dispute-codes-selected"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              rowData={selectedCode}
              columnDefs={DisputeCodesSelected}
              rowSelection="multiple"
              rowMultiSelectWithClick
              exportFile
              animateRows
              sideBar={false}
              fileName="Dispute Codes Selected"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              hideColumnsInPdf
              onCellFocused={onCellFocused}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 30) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        )}
      </div>
      <CommonModal
        open={openModal}
        viewAction
        viewHeader
        className="dialog-420"
        data-testid="common-modal-display"
        onOk={() => {
          setOpenModal(false);
          handleYes();
        }}
        okTitle="Yes"
        onClose={() => {
          setOpenModal(false);
        }}
        closeTitle="No"
        modalTitle="Confirmation Dialog"
        childrenComponent={
          <div className="p-3">{constantMessageData.NDC_LIMIT_TO_1000}</div>
        }
      />
    </div>
  );
};

export default DisputeActivity;
